import React from 'react';
import { getRegions } from '../../../utils/parks/getters';
import { getParkNameByCode } from '../../SearchEntryWidget/defaultData';
import LocationSelect from '../../SearchForm/children/LocationSelect';
export const ParkSelector = ({ onSelect, value, dogSelected, handleGTMFilterChange }) => {
    const innerOnSelect = (val) => {
        onSelect(val);
        if (handleGTMFilterChange) {
            handleGTMFilterChange('location', getParkNameByCode(val));
        }
    };
    return (<div className='bl-haven-regionParkSelector'>
      <LocationSelect value={value} regions={getRegions()} onChange={innerOnSelect} dogSelected={dogSelected}/>
    </div>);
};
